// extracted by mini-css-extract-plugin
export default {"tooltip":"src-components-common-DropdownPopup-dropdown-popup-module__tooltip_ULOL"};